import { render, staticRenderFns } from "./SelfReportModal.vue?vue&type=template&id=3962db5e"
import script from "./SelfReportModal.vue?vue&type=script&lang=js"
export * from "./SelfReportModal.vue?vue&type=script&lang=js"
import style0 from "./SelfReportModal.vue?vue&type=style&index=0&id=3962db5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports